import * as React from "react";
import { Input } from "./input";
import { cn } from "../../lib/utils";

export interface PhoneInputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "value" | "onChange"
  > {
  value?: string;
  /** onChange reçoit directement la valeur de l'input (string) */
  onChange?: (value: string) => void;
  /** Gardé pour compatibilité, ignoré désormais. */
  defaultCountryCode?: string;
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, value = "", onChange, defaultCountryCode, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      onChange?.(newValue);
    };

    return (
      <Input
        type="tel"
        className={cn("flex-1", className)}
        ref={ref}
        value={value}
        onChange={handleChange}
        placeholder={props.placeholder ?? "Téléphone (ex: +33 6 12 34 56 78)"}
        {...props}
      />
    );
  }
);
PhoneInput.displayName = "PhoneInput";

export { PhoneInput };
